const searchHeroSlide = {
  displayField: 'subhead',
  name: 'Search Hero Slide',
  description: 'Used for Search Hero',
  fields: [
    {
      id: 'image',
      name: 'Image',
      type: 'Link',
      localized: false,
      required: true,
      validations: [],
      disabled: false,
      omitted: false,
      linkType: 'Asset'
    },
    {
      id: 'header',
      name: 'Header',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'subhead',
      name: 'Subhead',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'ctaUrl',
      name: 'Cta URL',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    }
  ],
  sys: {
    id: 'searchHeroSlide',
    version: 16,
    updatedAt: '2023-08-03T14:26:50.073Z'
  }
};
export default searchHeroSlide;